// extracted by mini-css-extract-plugin
export default {"wrapper":"S1-z","message":"T1-z","image":"U1-z"};